import { FmsRole, PortalRole } from '../../../../domain/auth/service/auth.service';
import { OrganizationDTO } from "../../../../domain/organization/dto/OrganizationDTO";
import { UserAccessesInsideOrgDto } from "../../../../domain/organization/dto/UserAccessesInsideOrgDto";
import { ProfileDTO } from "../../../../domain/user/profile/dto/ProfileDTO";
import { VideoShowDto } from "../../../../domain/user/dto/VideoShowDto";

export class InitDataDTO {
  organizations: OrganizationWithAccesses[];
  userAccess: InitDataUserAccess;
  profile: ProfileDTO;
  videoShowDto: VideoShowDto;
  isNewOrgCanBeCreated: boolean;

  constructor(
    organizations: OrganizationWithAccesses[],
    userAccess: InitDataUserAccess,
    profile: ProfileDTO,
    videoShowDto: VideoShowDto,
    isNewOrgCanBeCreated: boolean
  ) {
    this.organizations = organizations;
    this.userAccess = userAccess;
    this.profile = profile;
    this.videoShowDto = videoShowDto;
    this.isNewOrgCanBeCreated = isNewOrgCanBeCreated;
  }

  static deserialize(object: InitDataDTO): InitDataDTO {
    return new InitDataDTO(
      object.organizations.map((organization) => OrganizationWithAccesses.deserialize(organization)),
      object.userAccess,
      object.profile,
      object.videoShowDto,
      object.isNewOrgCanBeCreated,
    );
  }
}

export class OrganizationWithAccesses {
  organization: OrganizationDTO;
  userAccesses: UserAccessesInsideOrgDto;

  constructor(
    organization: OrganizationDTO,
    userAccesses: UserAccessesInsideOrgDto) {
    this.organization = organization;
    this.userAccesses = userAccesses;
  }

  static deserialize(object: OrganizationWithAccesses): OrganizationWithAccesses {
    return new OrganizationWithAccesses(object.organization, object.userAccesses);
  }
}

export interface InitDataUserAccess{
  userRole: FmsRole;
  portalRole: PortalRole;
}
